// @flow
import type { AreasOfFocus } from 'api/orgs';
import type { Action } from '../actions/areasOfFocus';

export type State = ?AreasOfFocus;

export default function areasOfFocus(state: State = null, action: Action) {
  switch (action.type) {
    case 'AREAS_OF_FOCUS_SET': {
      return action.areasOfFocus;
    }

    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
